<template>
  <div class="page-container">
    <van-nav-bar class="buying-navbar" :title="product.productType == 2 ? '委托竞买确认' : $route.meta.title" fixed left-arrow @click-left="goBack" />
    <div class="countDown-bg" v-if="countDownTime > 0">
      <span>支付剩余时间：</span>
      <van-count-down class="time" v-if="isCanBuy == true" :time="time" format="HH:mm:ss" @finish="onFinish"></van-count-down>
      <span v-else>已超时</span>
    </div>
    <div class="page pt-20">
      <van-cell :title="product.productType == 2 ? '拍品名称' : '产品名称'" :value="product.name" />
      <van-cell :title="product.productType == 2 ? '委托竞买额' : '购买金额'" :value="
          product.productType == 2
            ? numFormat(auctionPayAmount)
            : numFormat(payForm.tradeAmount * 100) + '元'
        " />
      <van-cell :title="product.productType == 2 ? '预计成交日' : '起息日'" :value="dateFormat(product.valueDate, 'YYYY-MM-DD')" />
      <van-cell :title="product.productType == 2 ? '拍品到期日' : '到期日'" :value="dateFormat(product.dueDate, 'YYYY-MM-DD')" />
      <van-cell :title="product.productType == 2 ? '折扣金额' : '预期收益'" :value="numFormat(returnAmount) + '元'" />
      <van-cell v-if="(channel.toUpperCase() == 'TA') & (payForm.rateCouponAmount > 0 && product.productType == 2)" title="(已包含折扣优惠)" :value="'+' + payForm.rateCouponAmount + '%'" />
      <van-cell v-if="product.productType == 2" title="当前出价" :value="numFormat(payForm.auctionAmount) + '元'" />
      <van-cell v-if="
          (channel.toUpperCase() == 'TA') &
          (payForm.cashCouponAmount > 0 || payForm.decreCouponAmount > 0)
        " title="优惠券减免" :value="
          '-' +
          numFormat(payForm.cashCouponAmount + payForm.decreCouponAmount) +
          '元'
        " />
      <van-cell v-if="(channel.toUpperCase() == 'TA') & (payForm.rateCouponAmount > 0 && product.productType != 2)" title="加息" :value="'+' + payForm.rateCouponAmount + '%'" />
      <van-cell v-if="vlRate > 0" title="七夕专属福利" :value="'+' + vlRate + '%'" />
      <van-cell v-if="payForm.discount > 0" title="满减金额" :value="'-' + numFormat(payForm.discount) + '元'" />
      <van-cell v-if="(channel.toUpperCase() == 'TA') & (payForm.experienceAmount > 0)" title="体验金收益减免" :value="'-' + numFormat(payForm.experienceAmount || 0) + '元'" />
      <van-cell title="实付金额" :value="numFormat(payForm.payAmount) + '元'" />
      <van-cell class="mt-20">
        <van-button class="confirm-ok" @click="onSubmit" type="danger" round size="large">确认</van-button>
      </van-cell>
      <van-cell>
        <van-button class="confirm-cancel" @click="handleBackPage" type="danger" round plain size="large">取消</van-button>
      </van-cell>
    </div>
    <bl-eft v-model="eftShow" :payType="payType" title="金额超出上限 请使用线下转账"></bl-eft>
  </div>
</template>

<script>
import session from "@/utils/session"
import * as PayApi from "@/api/pay"
import * as SpecialPayApi from "@/api/special"
import * as ProductApi from "@/api/product"
import BlEft from "@/components/bl-eft"
import { NavBar, Button, Cell, Toast, CountDown } from "vant"
import { mapGetters } from "vuex"
import moment from "moment"
export default {
  name: "index",
  data: () => ({
    payForm: {},
    product: {},
    returnAmount: "",
    eftShow: false,
    countDownTime: 0,
    time: 0,
    isCanBuy: true,
    specialBalance: 0,
    auctionPayAmount: 0,
    vlRate: 0
  }),
  beforeMount() {
    this.countDownTime = Number(this.$route.params.countDownTime)
    this.payForm = JSON.parse(localStorage.getItem("payForm")) || {} //session.getJson('payForm') || {};
    console.log("this.payForm == %O", this.payForm)
    this.getDetail()
    this.getReturnAmount()
    this.countDownDate()
    this.getOrderInfo()
  },
  methods: {
    countDownDate() {
      if (this.countDownTime) {
        let time = moment(this.countDownTime).diff(Date.now())
        this.time = time
        return time
      } else {
        this.time = 0
        return 0
      }
    },
    onFinish() {
      this.isCanBuy = false
    },
    goBack() {
      if (this.countDownTime) {
        this.$router.push({ name: "myorder" })
      } else {
        this.$router.push({ name: "home" })
      }
    },
    getDetail() {
      this._showLoading()
      ProductApi.detail(this.payForm.productId)
        .then((data) => {
          this._dismissLoading()
          this.product = data
          if (data.isProductBaseAccount === 1) {
            // 0：普通产品 1：特殊产品1 2：特殊产品2 是否限定为针对产品账户设置的产品，除了产品账户之外的余额无法购买
            this.getSpecialBalance()
          }
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
        })
    },
    handleBackPage() {
      this.$router.replace({ name: "home" })
    },
    getReturnAmount() {
      PayApi.getReturnAmount({
        productId: this.payForm.productId,
        amount: this.payForm.tradeAmount,
        orderId: this.payForm.id
      })
        .then((data) => {
          this.returnAmount = data
        })
        .catch((e) => {
          this._showToast(e.msg || e.message)
        })
    },
    getOrderInfo() {
      PayApi.getOrderInfo(this.payForm.id)
        .then((data) => {
          if (data) {
            this.payForm.cashCouponAmount = data.cashCouponAmount
            this.payForm.rateCouponAmount = data.rateCouponAmount
            this.payForm.decreCouponAmount = data.decreCouponAmount
            this.payForm.payAmount = data.payAmount
            this.payForm.discount = data.discount
            this.payForm.experienceAmount = data.experienceAmount
            this.vlRate = data.vlRate
            if (data.productType == 2) {
              // 1 普通产品 2 拍品
              this.auctionPayAmount = data.tradeAmount
              this.payForm.auctionAmount = data.auctionAmount
            }
          }
        })
        .catch((e) => {
          this._showToast(e.msg || e.message)
        })
    },
    fetchsingatureType() {
      let payForm = session.getJson("payForm") || {}
      let form = { orderId: payForm.id }
      if (this.product.productType == 4) {
        this.handleCanBuy()
      } else {
        PayApi.getSignatureResult(form).then((data) => {
          if (data === "2") {
            // 协议签署完成进入新网页面
            this.handleCanBuy()
          } else {
            this._dismissLoading()
            Toast("协议未签署完成")
            setTimeout(() => {
              this.$router.replace({ name: "home" })
            }, 2000)
          }
        })
      }
    },
    onSubmit() {
      if (this.countDownTime) {
        if (this.isCanBuy) {
          this._showLoading()
          this.fetchsingatureType()
        } else {
          this.$toast("支付时间已超时")
        }
      } else {
        this._showLoading()
        this.fetchsingatureType()
      }
    },
    handleCanBuy() {
      if (this.product.isProductBaseAccount === 1) {
        // 0：普通产品 1：特殊产品1 2：特殊产品2 是否限定为针对产品账户设置的产品，除了产品账户之外的余额无法购买
        this.onSpecialBalancePay()
      } else {
        // ProductApi.canbuy(this.payForm.productId, this.payForm.tradeAmount)
        //   .then((data) => {
        //     if (data.canBuy) {
        switch (this.payForm.pattern_buying) {
          case "2": // '在线支付',
            this.onLinePayment()
            break
          case "3": // '余额支付',
            this.onBalancePay()
            break
        }
        // } else {
        //   this._dismissLoading()
        //   Toast(data.msg || data.message)
        // }
        // })
        // .catch((e) => {
        //   this._dismissLoading()
        //   Toast(e.msg || e.message)
        // })
      }
    },
    // 在线支付
    onLinePayment() {
      PayApi.getNewPayurl(this.payForm)
        .then((data) => {
          this._dismissLoading()
          location.href = data
        })
        .catch((e) => {
          this._dismissLoading()
          if (e.code == 2006) {
            this.eftShow = true
            return
          } else if (e.code == 5001) {
            Toast(e.msg || e.message)
            // this.handleBackPage()
            localStorage.removeItem("payForm")
            session.del("payForm")
          } else {
            Toast(e.msg || e.message)
          }
        })
    },

    onBalancePay() {
      const userInfo = this.userInfo
      const router = this.$router
      const route = this.$route
      if (
        Number(this.payForm.payAmount / 100 || 0) >
        Number(this.userInfo.balance || 0) / 100
      ) {
        this._dismissLoading()
        if (this.payType && !this.payType.onlinePay) {
          Toast({
            message: "余额不足请使用线下支付",
            duration: 1000,
            onClose: function () {
              router.push({
                path: "/recharge_offline",
                query: { redirect: route.fullPath }
              })
            }
          })
        } else {
          Toast({
            message: "余额不足请先充值余额",
            onClose: function () {
              if (userInfo.isBindCard) {
                // router.push({ name: "recharge_1" })
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath }
                })
              } else if (userInfo.isAuthName) {
                router.push({ name: "recharge_2" })
              } else {
                router.push({ name: "recharge_3" })
              }
            }
          })
        }
        return
      }
      this._showLoading()
      PayApi.getNewBalancepay(this.payForm)
        .then((data) => {
          this._dismissLoading()
          if (this.product.productType == 4) {
            this.$router.push({
              name: "experience_ing",
              query: { orderId: data }
            })
          } else {
            this.$router.push({
              name: "paySuccess",
              query: {
                investId: data,
                productType: this.product.productType,
                auctionPayAmount: this.auctionPayAmount
              }
            })
          }
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
          if (e.code == 5001) {
            // this.handleBackPage()
            localStorage.removeItem("payForm")
            session.del("payForm")
          }
        })
    },

    // 获取特殊产品目前可用余额
    getSpecialBalance() {
      SpecialPayApi.getSpecialBalance(this.payForm.productId)
        .then((data) => {
          if (data && data.length > 0) {
            this.specialBalance = data[0].balance
          }
        })
        .catch((e) => {
          this.$toast(e.msg || e.message)
        })
    },

    // 特殊产品余额支付
    onSpecialBalancePay() {
      const userInfo = this.userInfo
      const router = this.$router
      const route = this.$route
      if (
        Number(this.payForm.payAmount || 0) >
        Number(this.specialBalance || 0) / 100
      ) {
        this._dismissLoading()
        if (this.payType && !this.payType.onlinePay) {
          Toast({
            message: "余额不足请使用线下支付",
            duration: 1000,
            onClose: function () {
              router.push({
                path: "/recharge_offline",
                query: { redirect: route.fullPath }
              })
            }
          })
        } else {
          Toast({
            message: "余额不足请先充值余额",
            onClose: function () {
              if (userInfo.isBindCard) {
                // router.push({ name: "recharge_1" })
                this.$router.push({
                  name: "recharge_offline",
                  query: { redirect: this.$route.fullPath }
                })
              } else if (userInfo.isAuthName) {
                router.push({ name: "recharge_2" })
              } else {
                router.push({ name: "recharge_3" })
              }
            }
          })
        }
        return
      }
      this._showLoading()
      SpecialPayApi.specialBalancePay(this.payForm)
        .then((data) => {
          this._dismissLoading()
          if (this.product.productType == 4) {
            this.$router.push({
              name: "experience_ing",
              query: { orderId: data }
            })
          } else {
            this.$router.push({
              name: "paySuccess",
              query: {
                investId: data,
                productType: this.product.productType,
                auctionPayAmount: this.auctionPayAmount
              }
            })
          }
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
          if (e.code == 5001) {
            // this.handleBackPage()
            localStorage.removeItem("payForm")
            session.del("payForm")
          }
        })
    }
  },
  computed: {
    ...mapGetters(["payType", "userInfo", "channel"])
  },
  components: {
    [NavBar.name]: NavBar,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Toast.name]: Toast,
    BlEft,
    [CountDown.name]: CountDown
  }
}
</script>

<style scoped lang="less">
.page-container {
  box-sizing: border-box;
  height: 100%;
  background-image: url("../../assets/img/home/footer-bg.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: center 85%;
  background-size: 60vw auto;
}
.countDown-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 15px 0;
  font-size: 15px;
  font-weight: 500;
  color: black;
  .time {
    font-size: 15px;
    font-weight: 500;
    color: black;
  }
}
.page {
  background: #fff;
}

.van-cell__title {
  color: @gray-dark;
}
.van-cell__value {
  color: @dark;
}
</style>